import { LatLng, LatLngTuple } from 'leaflet';

import {
  AddressFull,
  AddressTeaser,
  QueryResponse,
  BoundaryResponse,
} from './containers/types';
import { API_URL, API_URL_OPTIONS } from '../../shared/config/constants';


export const addressReverseGeocode = (
  position: LatLng,
  callback: (address: AddressFull) => void,
) => {
  fetch(`${API_URL}/v1/reports/address/revgeo?lat=${position.lat}&lng=${position.lng}`, API_URL_OPTIONS)
    .then((response) => response.json())
    .then((response: QueryResponse<AddressFull>) => {
      callback(response.response);
    })
    .catch((error) => console.log(error));
};

export const addressLookup = (
  item: AddressTeaser,
  callback: (address: AddressFull) => void,
) => {
  fetch(`${API_URL}/v1/reports/address/lookup/${item.id}`, API_URL_OPTIONS)
    .then((response) => response.json())
    .then((response: QueryResponse<AddressFull>) => {
      callback(response.response);
    })
    .catch((error) => console.log(error));
};

export const addressSuggestSingle = (
  addressString: string,
  callback: (address: AddressFull) => void,
) => {
  fetch(`${API_URL}/v1/reports/address/suggest?q=${addressString}`, API_URL_OPTIONS)
    .then((response) => response.json())
    .then((response: AddressTeaser[]) => {
      if (!response[0]) return;
      addressLookup(response[0], callback);
    })
    .catch((error) => console.log(error));
};

export const getCategories = (
  gpsCoordinates: LatLngTuple,
  callback: (data: any) => void,
  updateInBounds: (inBounds: string) => void,
) => {
  fetch(`${API_URL}/v1/reports/categories?lat=${String(gpsCoordinates[0])}&lng=${String(gpsCoordinates[1])}&rows=1`, API_URL_OPTIONS)
    .then((response) => response.json())
    .then((response: QueryResponse<BoundaryResponse>) => {
      if (!response.response.data.in_boundary) {
        updateInBounds('error');
        callback([]);
      } else {
        updateInBounds('success');
        callback(response.response.data.categories);
      }
    })
    .catch((error) => console.log(error));
};

export const getBoundary = () => {

};
